/**
 * Payroll Settings Page
 * Configure payroll settings for the organization
 */

import { createFileRoute, useParams } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { BriefcaseBusiness } from 'lucide-react';
import { SettingsPageHeader } from '@/components/ui';
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell';
import { formatDocumentTitle } from '@/lib/document-title';

export const Route = createFileRoute('/_auth/$orgId/settings/business-setup/payroll')({
  component: PayrollPage,
});

function PayrollPage() {
  const { orgId } = useParams({ from: '/_auth/$orgId/settings/business-setup/payroll' });

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Payroll')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="payroll">
        <SettingsPageHeader
          title="Payroll"
          description="Configure payroll settings for your organization."
        />

        <div className="max-w-2xl space-y-6">
          <div className="rounded-[var(--r-2xl)] border border-clovie-border-soft bg-clovie-surface p-6 shadow-soft">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[var(--r-xl)] bg-clovie-chip text-clovie-chip-fg">
                <BriefcaseBusiness className="h-5 w-5" />
              </span>
              <div>
                <h2 className="text-[20px] font-semibold text-clovie-text">
                  Payroll is coming soon
                </h2>
                <p className="mt-2 text-[15px] leading-6 text-clovie-muted">
                  Payroll settings will live here when payroll tools are available for your
                  organization.
                </p>
              </div>
            </div>
          </div>
        </div>
      </BusinessSetupPageShell>
    </>
  );
}
